(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('comp-highlight-diff');
  var table = document.getElementById('comp-table');
  if (!toggle || !table) return;

  toggle.addEventListener('change', function () {
    if (this.checked) {
      table.classList.add('highlight-active');
      highlightDifferences();
    } else {
      table.classList.remove('highlight-active');
      table.querySelectorAll('.comp-diff').forEach(function (c) { c.classList.remove('comp-diff'); });
    }
  });

  function highlightDifferences() {
    var rows = table.querySelectorAll('.comp-spec-row');
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('.comp-spec-val');
      if (cells.length < 2) return;
      var vals = [];
      cells.forEach(function (c) { vals.push((c.getAttribute('data-val') || c.textContent.trim()).toLowerCase()); });
      var allSame = vals.every(function (v) { return v === vals[0]; });
      if (!allSame) {
        cells.forEach(function (c) { c.classList.add('comp-diff'); });
      }
    });
  }

  // Sticky column shadow on scroll
  var scroll = document.querySelector('.comp-table-scroll');
  if (scroll) {
    scroll.addEventListener('scroll', function () {
      var cols = table.querySelectorAll('.comp-sticky-col');
      var shadow = scroll.scrollLeft > 0 ? '3px 0 6px rgba(0,0,0,0.06)' : 'none';
      cols.forEach(function (c) { c.style.boxShadow = shadow; });
    });
  }

  // Add to cart handler
  table.querySelectorAll('.comp-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.textContent = 'Adding...';
      btn.disabled = true;
      setTimeout(function () { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
    });
  });
});


  // === DRAG-TO-REORDER COLUMNS ===
  (function() {
    var tbl = document.getElementById('comp-table');
    if (!tbl) return;
    var style = document.createElement('style');
    style.textContent = '.drag-handle{display:flex;align-items:center;justify-content:center;padding:6px 0;margin-top:8px;cursor:grab;user-select:none;background:#f0f0f0;border-radius:4px;font-size:13px;color:#666;transition:background .15s;border:1px solid #ddd}.drag-handle:hover{background:#e0e0e0;color:#333}.comp-product-header.dragging{opacity:.5}.comp-product-header.drag-over{box-shadow:inset 0 0 0 2px #2c6ecb}';
    document.head.appendChild(style);

    function swapCols(from, to) {
      if (from === to) return;
      var rows = tbl.querySelectorAll('tr');
      for (var i = 0; i < rows.length; i++) {
        var cells = rows[i].children;
        if (from < cells.length && to < cells.length) {
          if (from < to) rows[i].insertBefore(cells[from], cells[to].nextSibling);
          else rows[i].insertBefore(cells[from], cells[to]);
        }
      }
    }

    var dragIdx = -1;
    var hdrs = tbl.querySelectorAll('thead .comp-product-header');
    hdrs.forEach(function(th, idx) {
      var handle = document.createElement('div');
      handle.className = 'drag-handle';
      handle.textContent = '\u2630 Reorder';
      th.querySelector('.comp-product-card').appendChild(handle);

      var colIndex = function() {
        var c = th.parentElement.children;
        for (var i = 0; i < c.length; i++) if (c[i] === th) return i;
        return -1;
      };

      handle.addEventListener('mousedown', function(e) {
        e.preventDefault(); dragIdx = colIndex(); th.classList.add('dragging');
      });
      th.addEventListener('mouseenter', function() { if (dragIdx >= 0) th.classList.add('drag-over'); });
      th.addEventListener('mouseleave', function() { th.classList.remove('drag-over'); });
      handle.addEventListener('touchstart', function(e) {
        e.preventDefault(); dragIdx = colIndex(); th.classList.add('dragging');
      }, {passive:false});
    });

    function endDrag() {
      if (dragIdx < 0) return;
      var over = tbl.querySelector('.drag-over');
      var toIdx = -1;
      if (over) { var c = over.parentElement.children; for (var i = 0; i < c.length; i++) if (c[i] === over) { toIdx = i; break; } }
      if (toIdx >= 0 && toIdx !== dragIdx) swapCols(dragIdx, toIdx);
      dragIdx = -1;
      tbl.querySelectorAll('.comp-product-header').forEach(function(h) { h.classList.remove('dragging','drag-over'); });
    }
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', function(e) {
      if (dragIdx < 0) return;
      var t = e.changedTouches[0];
      var el = document.elementFromPoint(t.clientX, t.clientY);
      while (el && !el.classList.contains('comp-product-header')) el = el.parentElement;
      if (el) el.classList.add('drag-over');
      endDrag();
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sauna-comparison-table"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('comp-highlight-diff');
  var table = document.getElementById('comp-table');
  if (!toggle || !table) return;

  toggle.addEventListener('change', function () {
    if (this.checked) {
      table.classList.add('highlight-active');
      highlightDifferences();
    } else {
      table.classList.remove('highlight-active');
      table.querySelectorAll('.comp-diff').forEach(function (c) { c.classList.remove('comp-diff'); });
    }
  });

  function highlightDifferences() {
    var rows = table.querySelectorAll('.comp-spec-row');
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('.comp-spec-val');
      if (cells.length < 2) return;
      var vals = [];
      cells.forEach(function (c) { vals.push((c.getAttribute('data-val') || c.textContent.trim()).toLowerCase()); });
      var allSame = vals.every(function (v) { return v === vals[0]; });
      if (!allSame) {
        cells.forEach(function (c) { c.classList.add('comp-diff'); });
      }
    });
  }

  // Sticky column shadow on scroll
  var scroll = document.querySelector('.comp-table-scroll');
  if (scroll) {
    scroll.addEventListener('scroll', function () {
      var cols = table.querySelectorAll('.comp-sticky-col');
      var shadow = scroll.scrollLeft > 0 ? '3px 0 6px rgba(0,0,0,0.06)' : 'none';
      cols.forEach(function (c) { c.style.boxShadow = shadow; });
    });
  }

  // Add to cart handler
  table.querySelectorAll('.comp-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.textContent = 'Adding...';
      btn.disabled = true;
      setTimeout(function () { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
